import i18n from '../i18n';

export function DisabledUserName() {
  return <em className="text-gray-400 not-italic italic">{i18n.t('disabled-user-name', { ns: 'social' })}</em>;
}

export function getDisabledUserName(): string {
  return i18n.t('disabled-user-name', { ns: 'social' });
}
